import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=e4fa57f8&scoped=true&"
import script from "./Title.js?vue&type=script&lang=js&"
export * from "./Title.js?vue&type=script&lang=js&"
import style0 from "./Title.scss?vue&type=style&index=0&id=e4fa57f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fa57f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
